<ng-container [formGroup]="formGroup">
  @let visibleSegments = visibleSegments$ | async;
  <mat-form-field subscriptSizing="dynamic" [appearance]="appearance" [ngClass]="className">
    @if (showLabel) {
      <mat-label [translate]="label.length ? label : 'scenario.events.formLabel.segments' | translate"></mat-label>
    }
    <mat-select 
      #segment 
      panelWidth='null'
      panelClass="segment-select"
      (focus)="segment.open()"
      [placeholder]="placeholder"
      (closed)="searchTerm.reset('')"
      [attr.data-cy]="e2eTag"
      [formControlName]="control"
      [multiple]="multi"
      (selectionChange)="toggleSelection($event)">
      @if (searchEnabled) {
        <input class="-mt-2" [formControl]="searchTerm" type="text" [placeholder]="'scenario.events.searchLabel.segments' | translate"/>
      }
      @if (multi) {
        <div class="flex items-center p-2 mb-2 w-full">
          <div class="flex items-center gap-2 divide-x divide-gray-200 mr-4">
            <button type="button" data-cy="select-all" class="text-[13px] hover:bg-soft-blue text-digital-blue font-medium" (click)="selectAll()">
              {{ 'data.select.all' | translate }}
            </button>
            <button type="button" data-cy="deselect-all" class="text-[13px] pl-2 hover:bg-soft-blue text-digital-blue font-medium" (click)="deselectAll()">
              {{ 'data.select.deselectAll' | translate }}
            </button>
            <button type="button" data-cy="select-none" class="text-[13px] pl-2 hover:bg-soft-blue text-digital-blue font-medium" (click)="selectNone()">
              {{ 'data.select.none' | translate }}
            </button>
          </div>
          <div class="text-[13px] ml-auto" data-cy="selected-segments-count">
            {{ 'data.select.count' | translate: { count: segments.value?.length, total: visibleSegments?.length } }}
          </div>
        </div>
      }
      @if (enableGlobalSelect) {
        <mat-option
          [value]="globalValue">
          {{ globalValue | uppercase }}
        </mat-option>
      }
      @for (segment of visibleSegments; track segment.id) {
        <mat-option [style]="segment.visible ? 'display:block' : 'display:none'"
          [disabled]="disabledOptions.includes(segment.id)"
          [value]="segment.id">
          {{ segment.name }}
        </mat-option>
      }
    </mat-select>
    @if (suffix && hasValue) {
      <div matIconSuffix class="pr-2">
        <mat-icon (click)="reset($event)">clear</mat-icon>
      </div>
    }
    @if (helpText.length) {
      <mat-hint>{{ helpText }}</mat-hint>
    }
    <mat-error [translate]="'milestones.errors.required'"></mat-error>
  </mat-form-field>
</ng-container>
